<!-- Start: Main -->
<div id="main">

    <app-header></app-header>

    <app-sidebar></app-sidebar>

    <!-- Start: Content-Wrapper -->
    <section id="content_wrapper">

        <!-- breadCrumbs-->
        <!-- <app-breadcrumbs></app-breadcrumbs> -->

        <!-- Begin: Content -->
        <section id="content" style="margin-top: 50px" class="table-layout animated fadeIn">


            <!-- begin: .tray-center -->
            <div class="tray tray-center">




                <router-outlet></router-outlet>


            </div>

        </section>
        <!-- End: Content -->

    </section>
    <!-- End: Right Sidebar -->

    <app-footer> </app-footer>

</div>
